const textStyles = {
  "sidebar-group": {
    fontWeight: "bold",
    letterSpacing: "widest",
  },
  header: {
    fontSize: "lg",
    fontWeight: "700",
  },
  label: {
    fontSize: "sm",
    color: "text.soft",
    fontWeight: "700",
  },
  // test
  strong: {
    fontWeight: "500",
  },
  badge: {
    fontSize: "xs",
    textTransform: "uppercase",
    fontWeight: "500",
  },
  navLink: {
    fontWeight: "500",
  },
  indicator: {
    fontSize: "sm",
  },
  title: {
    fontWeight: "semibold",
    fontSize: "lg",
  },
  description: {
    fontSize: "md",
    fontWeight: "normal",
  },
  descriptionValue: {
    fontSize: "md",
    fontWeight: "medium",
  },
  formLabel: {
    fontSize: "md",
  },
  switchLabel: {
    fontSize: "sm",
    // fontFamily: "mono",
    // fontWeight: "semibold",
    // textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
};

export default textStyles;
